import { defineComponent as l, openBlock as o, createBlock as r, unref as p, mergeProps as m, withCtx as d, createElementVNode as e } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const h = /* @__PURE__ */ l({
  name: "IconAddImage",
  __name: "IconAddImage",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const n = t;
    return (A, a) => (o(), r(p(u), m(n, { "view-box": "0 0 24 24" }), {
      default: d(() => [...a[0] || (a[0] = [
        e("path", { d: "M19 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 1.5A.5.5 0 0 0 18.5 4v1.5H17a.5.5 0 0 0 0 1h1.5V8a.5.5 0 0 0 1 0V6.5H21a.5.5 0 0 0 0-1h-1.5V4A.5.5 0 0 0 19 3.5" }, null, -1),
        e("path", { d: "M2.25 19V7A1.75 1.75 0 0 1 4 5.25h9a.75.75 0 0 1 0 1.5H4A.25.25 0 0 0 3.75 7v12A.25.25 0 0 0 4 19.25h15A.25.25 0 0 0 19.25 19v-7a.75.75 0 0 1 1.5 0v7A1.75 1.75 0 0 1 19 20.75H4A1.75 1.75 0 0 1 2.25 19" }, null, -1),
        e("path", { d: "M11 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0m3.274 1.649a1.25 1.25 0 0 1 1.432-.038l.092.067 4.67 3.736a.75.75 0 0 1-.937 1.172l-4.507-3.605-8.526 7.58a.75.75 0 0 1-.996-1.122l8.685-7.72.087-.07" }, null, -1),
        e("path", { d: "M6.269 13.653a1.25 1.25 0 0 1 1.452-.021l.09.07 2.627 2.196a.75.75 0 0 1-.962 1.15l-2.461-2.059-3.517 3.127a.75.75 0 0 1-.996-1.12l3.678-3.27.089-.073" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  h as default
};
